import { render, staticRenderFns } from "./document-history-actions.vue?vue&type=template&id=0123bbeb&scoped=true&lang=pug&"
import script from "./document-history-actions.vue?vue&type=script&lang=ts&"
export * from "./document-history-actions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0123bbeb",
  null
  
)

export default component.exports